import Vue from 'vue';
import Router from 'vue-router';

import RouterComponent from './components/RouterComponent.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('./views/main/Start.vue'),
      children: [
        {
          path: 'login',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('./views/Login.vue'),
        },
        {
          path: 'redirect',
          component: () => import('./views/Redirect.vue'),
        },
        {
          path: 'set-password',
          name: 'password/set',
          component: () => import('./views/PasswordSet.vue'),
        },
        {
          path: 'recover-password',
          component: () => import('./views/PasswordRecovery.vue'),
        },
        {
          // TODO: remove
          path: 'reset-password',
          component: () => import('./views/ResetPassword.vue'),
        },
        {
          path: 'main',
          component: () => import('./views/main/Main.vue'),
          redirect: 'main/dashboard',
          children: [
            {
              path: 'dashboard',
              component: () => import('./views/main/Dashboard.vue'),
            },
            {
              path: 'profile',
              component: RouterComponent,
              redirect: 'profile/view',
              children: [
                {
                  path: 'view',
                  component: () => import('./views/main/profile/Profile.vue'),
                },
              ],
            },
            {
              path: 'apps',
              component: RouterComponent,
              redirect: 'apps/all',
              children: [
                {
                  path: ':id',
                  name: 'main-apps-app',
                  component: () => import('./views/main/apps/Apps.vue'),
                  redirect: ':id/scans',
                  children: [
                    {
                      path: 'scans',
                      name: 'main-apps-app-scans',
                      component: () => import('./views/main/apps/Scans.vue'),
                    },
                    {
                      path: 'consumers',
                      name: 'main-apps-app-consumers',
                      component: () =>
                        import('./views/main/apps/Consumers.vue'),
                    },
                    {
                      path: 'consumers/create',
                      name: 'main-apps-app-consumers-create',
                      component: () =>
                        import('./views/main/apps/CreateConsumer.vue'),
                    },
                    {
                      path: 'consumers/edit',
                      name: 'main-apps-app-consumers-edit',
                      component: () =>
                        import('./views/main/apps/CreateConsumer.vue'),
                    },
                  ],
                },
              ],
            },
            {
              path: 'admin',
              component: () => import('./views/main/admin/Admin.vue'),
              redirect: 'admin/users/all',
              children: [
                {
                  path: 'users',
                  redirect: 'users/all',
                },
                {
                  path: 'users/all',
                  component: () => import('./views/main/admin/AdminUsers.vue'),
                },
                {
                  path: 'users/edit/:id',
                  name: 'main-admin-users-edit',
                  component: () => import('./views/main/admin/CreateUser.vue'),
                },
                {
                  path: 'users/create',
                  name: 'main-admin-users-create',
                  component: () => import('./views/main/admin/CreateUser.vue'),
                },
                {
                  path: 'apps',
                  redirect: 'apps/all',
                },
                {
                  path: 'apps/all',
                  component: () =>
                    import('./views/main/admin/Applications.vue'),
                },
                {
                  path: 'apps/edit/:id',
                  name: 'main-admin-apps-edit',
                  component: () =>
                    import('./views/main/admin/CreateApplication.vue'),
                },
                {
                  path: 'apps/create',
                  name: 'main-admin-apps-create',
                  component: () =>
                    import('./views/main/admin/CreateApplication.vue'),
                },
                {
                  path: 'countries',
                  redirect: 'countries/all',
                },
                {
                  path: 'countries/all',
                  component: () => import('./views/main/admin/Countries.vue'),
                },
                {
                  path: 'countries/edit/:id',
                  name: 'main-admin-countries-edit',
                  component: () =>
                    import('./views/main/admin/EditCountries.vue'),
                },
                {
                  path: 'countries/create',
                  name: 'main-admin-countries-create',
                  component: () =>
                    import('./views/main/admin/EditCountries.vue'),
                },
                {
                  path: 'partners',
                  redirect: 'partners/all',
                },
                {
                  path: 'partners/all',
                  component: () => import('./views/main/admin/Partners.vue'),
                },
                {
                  path: 'partners/edit/:id',
                  name: 'main-admin-partners-edit',
                  component: () =>
                    import('./views/main/admin/CreatePartner.vue'),
                },
                {
                  path: 'partners/create',
                  name: 'main-admin-partners-create',
                  component: () =>
                    import('./views/main/admin/CreatePartner.vue'),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/*',
      redirect: '/',
    },
  ],
});
